import { Component, Input } from '@angular/core';

@Component({
  selector: 'kpi-card',
  templateUrl: 'kpi-card.html'
})
export class KpiCardComponent {
  interger = '0';
  fraction = '0';
  @Input() title: any;
  @Input() ready = false;
  @Input() error: boolean;
  @Input() set current(value: number) {
    this.interger = '0';
    this.fraction = '0';
    if (value) {
      let split = (value + '').split('.');
      this.interger = split[0];
      if (split[1]) {
        this.fraction = split[1];
      }
    }
  }
  @Input() variation: number;
  @Input() unit: string;
  @Input() reverse;
  @Input() displayUnit = true;
  @Input() showDecimals;

  get absoluteVariation() {
    return Math.abs(Number(this.variation.toFixed(1)));
  }

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/kpi-card/kpi-card.ts